import React from "react";
import "../../admin_resources/css/admin_style.css";

const Admin_Footer = () => {
  return (
    <div className="admin_footer">
      <div className="bx_sch_btm bg_1"></div>
      <div className="sec-footer" style={{textAlign:"center", marginBottom:"20px"}}>Copyright ⓒ ASOBI EDUCATION All Rights Reserved.</div>
    </div>
  );
};

export default Admin_Footer;
